export default __webpack_public_path__ + "static/media/slab3.85c37dfe.png";